module.exports = __webpack_public_path__ + "img/1-1.37b4d47f.jpg";